import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MainService } from 'src/app/services/main.service';
import 'bootstrap';

@Component({
    selector: 'app-tax-consent',
    templateUrl: './tax-consent.component.html',
    styleUrls: ['./tax-consent.component.scss']
})

export class TaxConsentComponent implements OnInit {
    language = JSON.parse(localStorage.getItem('language'));
    language_flag = localStorage.getItem('language_flag');


    @Input()
    disableHeader = false

    private personalID: string;
    uid: string;
    AgentID: any;
    isVerifyPid:Boolean;

    taxYear = 2565; // new Date().getFullYear() + 543;
    isAcceptConsent = true; // should get data from api
    taxConsentStep1 = true;
    taxConsentStep2 = false;
    taxConsentStep3 = false;
    taxErrorMSG = '';
    startYear = 2565; // Start Tax Consent Year
    selectYear = [];

    constructor(private route: ActivatedRoute, private router: Router, private mainService: MainService,
        private loader: NgxUiLoaderService) { }

    ngOnInit() {
        this.personalID = sessionStorage.getItem('PIDNo');
        this.AgentID = sessionStorage.getItem('AgentID');
        this.isVerifyPid = JSON.parse(sessionStorage.getItem('CType'));
        if (this.personalID == null || this.personalID === '' || this.isVerifyPid == false ) {
            this.router.navigate(['/fund-service-unit']);
        }

        const y = this.taxYear - this.startYear;
        const backYear = this.clamp(y, 0, 10);
        for (let i = 0; i <= backYear; i++) {
            this.selectYear.push(this.taxYear - i);
        }

        this.getTaxConsentData();
    }

    clamp(number, min, max) {
        return Math.max(min, Math.min(number, max));
    }

    selectTaxYear(value) {
        this.taxYear = value;
    }
    onChangeTaxConsent(isAccept) {
        this.isAcceptConsent = isAccept;
    }
    checkTaxConsent() {
        if (this.isAcceptConsent) {
            this.sendTaxConsentData();
        } else {
            this.taxConsentStep1 = false;
            this.taxConsentStep2 = true;
            this.taxConsentStep3 = false;
        }
    }

    gobackTaxConsent() {
        this.taxConsentStep1 = true;
        this.taxConsentStep2 = false;
        this.taxConsentStep3 = false;
    }

    sendTaxConsentData() {
        // send tax consent to api
        this.mainService.sendTaxConsent(this.personalID, this.isAcceptConsent, this.taxYear, this.AgentID, this.language_flag)
            .subscribe(response => {
                if (response['Success']) {
                    this.taxConsentStep1 = false;
                    this.taxConsentStep2 = false;
                    this.taxConsentStep3 = true;
                    // this.router.navigate(['/client-report/', 'ED']);
                } else {
                    this.taxErrorMSG = response['Message']
                    $('#taxError').modal('show');
                    this.gobackTaxConsent();
                }
            });
    }

    getTaxConsentData() {
        this.mainService.getTaxConsent(this.personalID, this.AgentID)
            .subscribe(response => {
                if (response['Success']) {
                    this.taxYear = response['Result']['Year'];
                    this.isAcceptConsent = response['Result']['Given'];
                }
            });
    }

    gobackToMain() {
        this.router.navigate(['/client-report/', 'ED']);
    }
}
